import { NgModule,CUSTOM_ELEMENTS_SCHEMA, ApplicationModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UploadModule } from '@progress/kendo-angular-upload';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NglModule} from 'ng-lightning';

import { RaCreateComponent } from './ra-create.component';
import { WizardModule } from '../../../common/component/wizard/wizard.module';
import { ModalModule } from '../../../common/component/modal/modal.module';
import { SpinnerModule } from '../../../common/component/spinner/spinner.module';
import { AlertModule } from '../../../common/component/alert/alert.module';
import { PropertyEditModule } from './property-edit/property-edit.module';
import { ProcessSettingsModule } from './process-settings/process-settings.module';
import { UpdateStateService } from '../../../core';
import { QaSelectCompanyModule } from '../ra-create/qa-select-company/qa-select-company.module'
import { QaEmailVerificationModule} from '../ra-create/qa-email-verification/qa-email-verification.module'

@NgModule({
  imports: [
    CommonModule
    ,WizardModule
    ,FormsModule
    ,UploadModule
    ,DateInputsModule
    ,DropDownsModule
    ,NglModule
    ,ModalModule
    ,SpinnerModule
    ,AlertModule
    ,ApplicationModule
    ,PropertyEditModule
    ,ProcessSettingsModule
    ,QaSelectCompanyModule
    ,QaEmailVerificationModule
  ],
  declarations: [RaCreateComponent],
  exports: [RaCreateComponent],
  schemas:[ CUSTOM_ELEMENTS_SCHEMA ],
  providers: [UpdateStateService]
})
export class RaCreateModule { }
